import React from "react";
import { Utils } from "../utils";

interface Props {
  value: string;
  show?: boolean;
}

const RULES: { key: "length" | "letter" | "number" | "special"; label: string }[] = [
  { key: "length", label: "At least 8 characters" },
  { key: "letter", label: "Contains a letter" },
  { key: "number", label: "Contains a number" },
  { key: "special", label: "Contains a special character" },
];

const PasswordChecklist: React.FC<Props> = ({ value, show = true }) => {
  if (!show) return null;
  const status = Utils.checkPasswordStrength(value || "");
  return (
    <ul className="passwordChecklist" aria-label="Password requirements">
      {RULES.map((r) => {
        const passed = status[r.key];
        return (
          <li
            key={r.key}
            className={`passwordChecklist__item ${
              passed ? "passwordChecklist__item--ok" : ""
            }`}
          >
            <i
              className={`bi ${passed ? "bi-check-circle-fill" : "bi-circle"}`}
              aria-hidden="true"
            />
            <span>{r.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordChecklist;
